export const OPERATIONS_MODULE_KEY = 100101;
export const AI_USAGE_DASHBOARD_TITLE = 'AI Usage';
export const AI_USAGE_CARD_ICON = 'assets/svgIcons/scraii_ai_logo.svg';

export interface UsageDashboardDef {
  id: string;
  title: string;
  icon: string;
}

export const USAGE_DASHBOARDS_BY_MODULE: Record<number, UsageDashboardDef[]> = {
  [OPERATIONS_MODULE_KEY]: [
    {
      id: 'ai-usage',
      title: AI_USAGE_DASHBOARD_TITLE,
      icon: AI_USAGE_CARD_ICON,
    },
  ],
};

export function getUsageDashboardsForModule(moduleKey: number): UsageDashboardDef[] {
  return USAGE_DASHBOARDS_BY_MODULE[Number(moduleKey)] ?? [];
}

export function mapUsageDashboardToCard(
  def: UsageDashboardDef
): Record<string, unknown> {
  return {
    dashboard_nm: def.title,
    hide_flg: 'N',
    access_flg: 'Y',
    hist_access_flg: 'H',
    isUsageDashboard: true,
    usageDashboardId: def.id,
    active_image: def.icon,
  };
}
